<template>
    <div class="container mt-5">
        <h1>Partners</h1>
    </div>
</template>

<script>
    export default {
        name: "Partners",
        metaInfo: {
            title: 'Partners'
        }
    }
</script>

<style scoped>

</style>
